import Card from "@material-ui/core/Card";
import {ButtonBase, Divider, Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import NavIcon from "@material-ui/icons/ArrowForwardIosRounded";
import React from "react";
import CardContent from "@material-ui/core/CardContent";
import {LocalShippingRounded} from "@material-ui/icons";

export function CardOrdenCompra(props) {
    const {id, proveedor, fecha, onClick} = props;
    return (
        <>
            <Card className={'m-0 p-0'} elevation={0}>
                <ButtonBase style={{width: '100%', display: 'block', textAlign: 'left'}} onClick={onClick}>
                    <CardContent>
                        <Typography variant={"caption"} component={"span"} color={"textSecondary"} className={'mb-2 d-flex'}>
                            <LocalShippingRounded fontSize={"small"} color={"disabled"} className={'mr-1'}/><b>{fecha}</b>
                        </Typography>
                        <Grid container alignItems={"center"}>
                            <Grid item xs={11}>
                                <Typography color="textSecondary" gutterBottom>
                                    Orden de Compra {id}
                                </Typography>
                                <Typography color="textSecondary">
                                    {proveedor}
                                </Typography>
                            </Grid>
                            <Grid item xs={1}>
                                <NavIcon color={"primary"}/>
                            </Grid>
                        </Grid>
                    </CardContent>
                </ButtonBase>
            </Card>
            <Divider/>
        </>
    );
}
